import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetAllMarcaResponse } from '../../responses/produto/get-all-marca.response';
import { GetMarcaResponse } from '../../responses/produto/get-marca.response';
import { MarcaRequest } from '../../requests/produto/marca.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class MarcaService extends CommonService {
    constructor(
        private httpClient: HttpClient
    ) {
        super();
    }

    private readonly apiUrl = `${environment.urlApiProduto}marca`;

    /**
     * Obtém a lista de Marcas.
     */
    public getAll(nome: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetAllMarcaResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (nome) {
            params = params.set('nome', nome);
        }

        return this.httpClient
            .get<GetAllMarcaResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    /**
     * Exclui uma marca.
     */
    public delete(idMarca: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${idMarca}`;

        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Exclui múltiplas marcas.
     */
    public deleteBulk(idsMarca: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;

        return this.httpClient
            .post<ReturnStruct>(url, { idsMarca }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Obtém uma marca por ID.
     */
    public getById(idMarca: number): Observable<GetMarcaResponse> {
        const url = `${this.apiUrl}/${idMarca}`;

        return this.httpClient
            .get<GetMarcaResponse>(url, { ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    /**
     * Cria uma nova marca.
     */
    public create(request: MarcaRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Atualiza uma marca existente.
     */
    public update(idMarca: number, request: MarcaRequest): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${idMarca}`;

        return this.httpClient
            .put<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
